// extracted by mini-css-extract-plugin
export var linkContainer = "plan-site-module--link-container--2d68e";
export var linksTitle = "plan-site-module--links-title--7904e";